"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractSigningSource = contractSigningSource;
const SigningApi_1 = require("../../Signing/SigningApi");
/**
 * Dokumenty umowy ENVI jako źródło plików do podpisu: pliki z folderu sprawy „Umowa i zmiany”.
 * Każdy plik domyślnie bez grafiki; miejsce grafiki znajduje serwer przy nagłówku „Wykonawca”
 * w bloku podpisu, a gdy go nie znajdzie, użytkownik klika je na obrazie strony.
 */
function contractSigningSource(contract) {
    const { id, ourId, alias } = contract;
    // Alias bywa kopią oznaczenia (np. „DUW.AQM.02”) - wtedy go nie powtarzamy.
    const aliasPart = alias?.trim() && alias.trim() !== ourId ? ` ${alias.trim()}` : "";
    return {
        key: `contract-${id}`,
        listFiles: () => SigningApi_1.SigningApi.listContractSignableFiles(id),
        createJob: (files) => SigningApi_1.SigningApi.createContractJob(id, files),
        listSignatures: async () => (await SigningApi_1.SigningApi.listContractSignatures(id)).signatures,
        uploadSigned: (file) => SigningApi_1.SigningApi.uploadSignedToContract(id, file),
        // Umowy nie mają plakietki „podpisane” na liście, więc nie ma czego odświeżać.
        onChanged: () => { },
        // W folderze „Umowa i zmiany” leży też SWZ, plany płatności i protokoły: użytkownik sam wskazuje, co podpisuje.
        preselectFiles: false,
        graphicPlace: {
            locate: (file) => SigningApi_1.SigningApi.locateContractGraphicPlace(id, file.gdFileId),
            pageImage: (file, page) => SigningApi_1.SigningApi.contractFilePageImage(id, file.gdFileId, page),
        },
        texts: {
            subject: `umowa ${ourId}${aliasPart}`,
            inFolder: "w folderze „Umowa i zmiany”",
            thisHasAlready: "Ten kontrakt ma już",
        },
    };
}
